import React from "react";
import "./BackButton.scss";
import LeftArrow from "../../assets/icons/LeftArrow.svg";

const BackButton = ({ onClick }) => {
  return (
    <div className="back-button" onClick={onClick}>
      <div className="arrow">
        <img src={LeftArrow} alt="LeftArrow" />
      </div>
      <button>Back</button>
    </div>
  );
};

export default BackButton;
